import React from "react";
import { light_logo, light_logo3 } from "../../assets";

const DelarRegistrationContactSection = () => {
  let imgUrl =
    "http://localhost:3000/static/media/icon.55c3e53dd7dc01969882.png";
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex flex-col justify-center items-center gap-1">
      <h3 className="text-center text-[16px] font-medium">
        Do you have any questions? Contact us!
      </h3>
      <img
        src="https://wristlink.s3.me-south-1.amazonaws.com/9.svg"
        alt=""
        height={108}
        width={108}
        className="rounded-full mt-3"
      />
      <p className="text-[14px] text-center">Phone: +971 50 22 77747 </p>
      <p className="text-[14px] text-center">Email: info@wristlink.app </p>
    </section>
  );
};

export default DelarRegistrationContactSection;
